import { Scale } from "../../utils/Scale"

export class PongPos {

    static baseFps = () => 59.94125756758

    static titleX = () => Scale.width() * 0.35
    static titleY = () => Scale.height() * 0.1

    static directionsX = () => Scale.width() * 0.36
    static directionsY = () => Scale.height() * 0.3

    static difficultyTextY = () => Scale.height() * 0.02

    static timeRemainingX = () => Scale.width() * 0.02
    static timeRemainingY = () => Scale.height() * 0.85

    static timeRemainingCounterX = () => Scale.width() * 0.1
    static timeRemainingCounterY = () => Scale.height() * 0.92

    static addictometerX = () => Scale.width() * 0.02
    static addictometerY = () => Scale.height() * 0.2

    static explodeX = () => Scale.width() * -0.135
    static explodeY = () => Scale.height() * 0.075

    static difficultyButtonX = () => Scale.width() * 0.37
    static difficultyButtonY = () => Scale.height() * 0.57

    static difficultyButtonSpacing = () => Scale.width() * 0.02

    static paddleX = () => Scale.width() * 0.4
    static paddleY = () => Scale.height() * 0.5

    static vapingX = () => Scale.width() * 0.175
    static vapingY = () => Scale.height() * 0.44

    static smokingX = () => Scale.width() * 0.175
    static smokingY = () => Scale.height() * 0.295

    static scoresScreenX = () => Scale.x(0.33)
    static scoresScreenY = () => Scale.y(0.25)

    static usernameX = () => PongPos.scoresScreenX() + Scale.x(0.04)

    static scoreX = () => Scale.x(0.64)

    static scoresScreenButtonsY = () => Scale.height() * 0.8

}
